import React from 'react'
import FirebaseContext from "../../firebase/context";
import CompTema from "../components/CompTema";

import {
    Container,
    Paper,
    Grid,
    Breadcrumbs,

    Typography,
    CardMedia,
    Card,
    CardActions,
    IconButton
} from "@material-ui/core";
import { Link, withRouter } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CompTemaComent from '../components/CompTemaComent';
import UsuarioContext from '../contex/UsuarioContext';


const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
      },
}));


const style = {
    container: {
        // fixed: 1,
        // disableGutters: 1,
        // paddingTop: 8,
        // paddingBottom: 8
        width: '100%',
        // flexGrow: 1,
    },
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        // minHeight: 650,
        // minWidth: 650
    },
    paperMenu: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        // minHeight: 650,
        // minWidth: 100,
        // maxWidth: 300
    },
    link: {
        display: "flex"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#B5DEF1",
    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "20px"
    }
};

const PagListaTemas = (props) => {
    const { firebase, user } = React.useContext(FirebaseContext);
         ////////////////////////////////////////////////////////////////////  
        //  const usuarioContextLocal = React.useContext(UsuarioContext);
        //  const { setObjUsuario } = usuarioContextLocal;
         
        //  React.useEffect(() => {
        //      firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
        //          const arrayUsuario = snapshot.docs.map(doc => {
        //              let data = doc.data();
        //              let id = doc.id;
        //              return { id, ...data };
        //          });            
        //          setObjUsuario(arrayUsuario[0]);
        //          console.log('arrayUsuario');
        //          console.log(arrayUsuario);     
        //      });
        //  }, [])
     ///////////////////////////////////////////////////////////////////////////

    const classes = useStyles();

    const [temas, setTemas] = React.useState([]);
    const [temaSelected, setTemaSelected] = React.useState(0);
    const [tema, setTema] = React.useState({});
    const [size, setSize] = React.useState(8)
    const [showPractica, setShowPractica] = React.useState(false)
    const [temaId, setTemaId] = React.useState("")
   
    const videoAltura = size * 50

    const idCurso = props.match.params.cursoId;


    React.useEffect(() => {
        getTemas();
    }, []);

    function getTemas() {
        firebase.db.collection("colTemas").where("idCurso", "==", idCurso).get().then(snapshot => {
            const arrayTemas = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setTemas(arrayTemas);

        });
    }
  
    const goBack = () => {
        props.history.goBack()
    }

    return (

        <Container fullwidth style={style.container}>
            <Grid container spacing={1}>

                <Grid item xs={12} sm={size} style={style.gridTextfield}>
                    <Paper style={style.paper}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} style={style.gridTextfield}>
                                <Card style={style.card}>
                                    <iframe
                                        // width="560"
                                        height={videoAltura}
                                        src={tema.video}
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    />
                                    <CardActions>
                                        { showPractica ? (
                                        <IconButton aria-label="delete" className={classes.margin} 
                                        color="primary" onClick={() => setShowPractica(false)}>
                                        <PictureAsPdfIcon fontSize="large" />
                                        </IconButton>

                                        ): (
                                            <IconButton aria-label="delete" className={classes.margin} 
                                            color="primary" onClick={() => setShowPractica(true)}>
                                            <PictureAsPdfIcon fontSize="large" />
                                            </IconButton>
                                        )

                                        }                                                                              
                                        {
                                            size == 8 ? (
                                                <IconButton aria-label="delete" className={classes.margin} 
                                                color="primary" onClick={() => setSize(12)}>
                                                <ZoomInIcon fontSize="large" />
                                                </IconButton>
                                            ) : (
                                                <IconButton aria-label="delete" className={classes.margin} 
                                                color="primary" onClick={() => setSize(8)}>
                                                <ZoomOutIcon fontSize="large" />
                                                </IconButton>
                                                )
                                        }

                                    </CardActions>
                                </Card>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>


                <Grid item xs={12} sm={4} style={style.gridTextfield}>
                    <Paper style={style.paperMenu}>
                        <Grid container spacing={1}>
                            <Grid item xs={4} sm={12}>
                                <Breadcrumbs aria-label="breadcrumbs">
                                    <Link
                                        color="inherit"
                                        style={style.link}
                                        onClick={() => goBack()}
                                    >
                                        <ArrowBackIosIcon />
                                Anterior
                            </Link>
                                    <Typography color="textPrimary">Temas</Typography>
                                </Breadcrumbs>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            {
                                temas.map((tema, index) => {
                                    return <CompTema
                                        key={tema.id}
                                        tema={tema}
                                        index={index + 1}
                                        setTemaSelected={setTemaSelected}
                                        temaSelected={temaSelected}
                                        setTema={setTema}
                                        setTemaId={setTemaId}
                                    />
                                })
                            }
                        </Grid>

                    </Paper>
                </Grid>

{
    showPractica ? (
                <Grid item xs={12} sm={8} style={style.gridTextfield}>
                    <Paper style={style.paper}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} style={style.gridTextfield}>
                                <Card style={style.card}>
                                    <CardActions>
                                        <CardMedia
                                            component="iframe"
                                            height="315"
                                            image={tema.practica}
                                            title="Contemplative Reptile" />
                                    </CardActions>
                                </Card>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
    ): null
}

                <Grid item xs={12} sm={8} style={style.gridTextfield}>
                    <Paper style={style.paperMenu}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} style={style.gridTextfield}>
                                {
                                    temaId !== "" ? (
                                        <CompTemaComent 
                                        temaId={temaId}
                                        />

                                    ) : null
                                }

                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

            </Grid>
        </Container>
    )
}

export default withRouter(PagListaTemas)
